__turbopack_context__.v({
  "courseHeader": "CoursePage-module__0fg8gq__courseHeader",
  "courseHeaderContent": "CoursePage-module__0fg8gq__courseHeaderContent",
  "courseHeaderNoBreadcrumb": "CoursePage-module__0fg8gq__courseHeaderNoBreadcrumb",
  "labeledParagraph": "CoursePage-module__0fg8gq__labeledParagraph",
  "labeledParagraphContent": "CoursePage-module__0fg8gq__labeledParagraphContent",
  "labeledParagraphTitle": "CoursePage-module__0fg8gq__labeledParagraphTitle",
  "labeledParagraphs": "CoursePage-module__0fg8gq__labeledParagraphs",
  "main": "CoursePage-module__0fg8gq__main",
  "nowrapRange": "CoursePage-module__0fg8gq__nowrapRange",
  "summaryImage": "CoursePage-module__0fg8gq__summaryImage",
  "textbooksList": "CoursePage-module__0fg8gq__textbooksList",
});
